import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setStartDate, setEndDate } from '../../redux/actions/dateRangeActions';
import './CustomDatepicker.css';
import { format, parse } from 'date-fns';

const DateRangePicker = () => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useSelector((state) => state?.dateRangeReducer);

  const handleDateChange = (date, type) => {
    const formattedDate = format(date, 'dd-MM-yyyy'); 
    if (type === 'start') {
      dispatch(setStartDate(formattedDate));
    } else if (type === 'end') {
      dispatch(setEndDate(formattedDate));
    }
  };

  const parseDate = (dateStr) =>
    dateStr ? parse(dateStr, 'dd-MM-yyyy', new Date()) : null;

  return (
    <div className="flex gap-2  relative z-50">
      <div className="relative">
        <DatePicker
          selected={parseDate(startDate)}
          onChange={(date) => handleDateChange(date, 'start')}
          selectsStart
          startDate={parseDate(startDate)}
          endDate={parseDate(endDate)}
          dateFormat="dd-MM-yyyy"
          className="p-2 border border-gray-300 rounded-md w-[180px]"
          placeholderText="Start date"
          popperPlacement="bottom-start"
          popperClassName="datepicker-popper"
          popperProps={{ strategy: "fixed" }}
        />
      </div>

      <div className="relative">
        <DatePicker
          selected={parseDate(endDate)}
          onChange={(date) => handleDateChange(date, 'end')}
          selectsEnd
          startDate={parseDate(startDate)}
          endDate={parseDate(endDate)}
          minDate={parseDate(startDate)}
          dateFormat="dd-MM-yyyy"
          className="p-2 border border-gray-300 rounded-md w-[180px]"
          placeholderText="End date"
          popperPlacement="bottom-start"
          popperClassName="datepicker-popper"
          popperProps={{ strategy: "fixed" }}
        />
        
      </div>
    </div>
  );
};

export default DateRangePicker;
